import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SettingsService } from '@edtech-ui/core/services/admin-panel/settings.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, MatSlideToggleModule, MatButtonModule,MatIconModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {

  user: any = {};
  settings: any = {};
  loading = true;
  adminEmail = 'admin@sit.ac.in';

  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
    this.settingsService.getSettings().subscribe((res) => {
      this.user = res.user;
      this.settings = res.settings;
      this.loading = false;
    });
  }

  saveProfile() {
    console.log('Profile Saved', this.user);
  }

  toggleChange(settingKey: string) {
    this.settings[settingKey] = !this.settings[settingKey];
    console.log('Setting changed:', settingKey, this.settings[settingKey]);
  }

  enable2FA() {
    console.log('2FA enabled');
  }

  deleteAccount() {
    console.log('Account deleted');
  }
}
